import React, { useEffect, useState, useContext } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { DateTime } from "luxon";
import {
  NotificationManager,
} from "react-notifications";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import getAllInvitedCandidateResponse from "../../apis/inviteCandidate/getAllInvitedCandidate";
import revokeInviteCandidateResponse from "../../apis/inviteCandidate/revokeInviteCandidate";
import "./candidate.css";
import { UserTypeContext } from "../../AppRoute";
import DataTable from "../../components/DataTable/DataTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess.js";


const Candidate = ({ idContextTest }) => {
  const { userType } = useContext(UserTypeContext);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [allCandidateArr, setAllCandidateArr] = useState([]);
  const [openRevokeDialogue, setOpenRevokeDialogue] = useState(false);
  const [revokeCandidateDetails, setRevokeCandidateDetails] = useState({});
  const history = useNavigate();

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getAllCandidate();
      } catch (error) {
        setisDataLoaded(true);
      } finally {
        setisDataLoaded(true);
      }
    };
    fetchAllData();
  }, []);
  const getAllCandidate = async () => {
    let allCandidates = await getAllInvitedCandidateResponse();
    if (allCandidates.data.data) {
      const processedArr = allCandidates.data.data.map((cand) => ({
        ...cand,
        invitedDate: cand.createdAt ? formatDate(cand.createdAt) : "N/A",
        invitedByPerson: cand.user
          ? `${cand.user.firstName} ${cand.user.lastName}`
          : "N/A",
        expiryDate: cand.expiresOn ? formatDate(cand.expiresOn) : "N/A",
      }));
      setAllCandidateArr(processedArr);
    } else {
      setAllCandidateArr([]);
    }
  };
  const openRevokeModal = (value) => {
    setRevokeCandidateDetails(value);
    setOpenRevokeDialogue(true);
  };
  const closeRevokeModal = () => {
    setOpenRevokeDialogue(false);
  };
  const revokeCandidate = async () => {
    var payload = {
      isActive: false,
    };

    try {
      await revokeInviteCandidateResponse(
        revokeCandidateDetails.id,
        payload
      );
      NotificationManager.success("Revoke done", "Success", 10000);
      getAllCandidate();
      setOpenRevokeDialogue(false);
    } catch (error) {
      NotificationManager.error("Revoke failed", "Error", 10000);
      setOpenRevokeDialogue(false);
    }
  };

  const formatDate = (datetime) => {
    return DateTime.fromISO(datetime)
      .toLocal()
      .toFormat("MM/dd/yyyy");
  };

  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.createdAt;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  function dateFilterFn1(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.expiresOn;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    return filterValue ? new Date(filterValue) : null;
  }



  let columns = [
    {
      accessorKey: "firstName",
      header: "First Name",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "email",
      header: "Email",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "invitedDate",
      header: "Invited Date",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        <>
          {DateTime.fromISO(row.original.createdAt)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>
      )
    },
    {
      accessorKey: "invitedByPerson",
      header: "Invited By",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "expiryDate",
      header: "Invite Expiry Date",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: dateFilterFn1,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        <>
          {DateTime.fromISO(row.original.expiresOn)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>
      )
    },
    {
      id: "Revoke",
      header: "Revoke",
      cell: ({ row }) => (
        <>
          <button
            className='editBtn_manageSpoc'
            onClick={() => openRevokeModal(row.original)}
          >
            Edit
          </button>
        </>
      ),
      size: 80,
      enableSorting: false,
      enableColumnFilter: false,
    },
  ]

  const goToDashboard = () => {
    history("/admin-home");
  };

  return (
    <>
          <div className="main_container_admin_candidate">
            {!isDataLoaded ? (
              <div className="row padding_80 text-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                {userType === "Admin" ? (
                  <Grid container spacing={3}>
                    <div className="communityHeader_manageUser ">
                      <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                        <Tooltip title="Go Back to Dashboard" placement="bottom">
                          <ArrowBackIcon sx={{ fontSize: 20 }} />
                        </Tooltip>
                      </div>
                      <div className="communityTitle">Pending Candidate Invites</div>
                    </div>
                    <div className="candidate-table-container">
                      <DataTable
                        data={allCandidateArr}
                        columns={columns}
                        isLoading={!isDataLoaded}
                      />
                    </div>

                  </Grid>
                ) : userType === "" ? (
                  <div className="row padding_80 text-center">
                    <p className="fs-semi-bold fs-40 f-color">
                      Loading...
                    </p>
                  </div>
                ) : (
                  <UnauthorizedAccess />
                )}
              </>
            )}
          </div>
      <Dialog
        open={openRevokeDialogue}
        onClose={closeRevokeModal}
        aria-labelledby="customized-dialog-title"
      >
        <DialogContent
          className='removemodal_responsive'
        >
          <div className="text-center fs-semi-bold f-color fs-18">
            Do you want to revoke this invite?
          </div>
        </DialogContent>
        <DialogActions
          className=' responsiveRemove_Modal_button '
        >
          <div className="remove_modal revoke_adjust">
            <button
              type="button"
              className="btn_remove btn-skill cp"
              onClick={closeRevokeModal}
            >
              No
            </button>
            <button
              type="button"
              className="btn2 btn_primary ml_5 cp"
              onClick={revokeCandidate}
            >
              Yes
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Candidate;

